import { combineSlices } from "@reduxjs/toolkit";
import { editModeSlice } from "./editModeSlice";
import { modalRedirectSlice } from "./modalRedirectSlice";
import { successModeSlice } from "./successModeSlice";

export const uiSlice = combineSlices({
  successMode: successModeSlice.reducer,
  editMode: editModeSlice.reducer,
  modalRedirect: modalRedirectSlice.reducer,
})